// Config
export const START_LOADING = 'START_LOADING';
export const STOP_LOADING = 'STOP_LOADING';

// User
export const UPDATE_USER_DATA = 'UPDATE_USER_DATA';
export const LOGOUT = 'LOGOUT';
